import { render, staticRenderFns } from "./chitiet.vue?vue&type=template&id=1b65e2d0"
import script from "./chitiet.vue?vue&type=script&lang=js"
export * from "./chitiet.vue?vue&type=script&lang=js"
import style0 from "./chitiet.vue?vue&type=style&index=0&id=1b65e2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports